import { Button, Link } from '@mui/material'
import React from 'react'

function SSOInfo({link}:{link:string}) {
  return (
    <div>
      This is documentation section where you can know about all about attributes and possible values. Please <Link href={link} target='_blank'> click here</Link> to open document.
    </div>
  )
}

export default SSOInfo